// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__UH9bg","question":"Question_question__1ZDC5","description":"Question_description__169lg"};